/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UnmatchedPlumeImage } from './UnmatchedPlumeImage';
import {
    UnmatchedPlumeImageFromJSON,
    UnmatchedPlumeImageFromJSONTyped,
    UnmatchedPlumeImageToJSON,
    UnmatchedPlumeImageToJSONTyped,
} from './UnmatchedPlumeImage';

/**
 * 
 * @export
 * @interface PaginatedUnmatchedPlumeImageList
 */
export interface PaginatedUnmatchedPlumeImageList {
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnmatchedPlumeImageList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnmatchedPlumeImageList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<UnmatchedPlumeImage>}
     * @memberof PaginatedUnmatchedPlumeImageList
     */
    results: Array<UnmatchedPlumeImage>;
}

/**
 * Check if a given object implements the PaginatedUnmatchedPlumeImageList interface.
 */
export function instanceOfPaginatedUnmatchedPlumeImageList(value: object): value is PaginatedUnmatchedPlumeImageList {
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedUnmatchedPlumeImageListFromJSON(json: any): PaginatedUnmatchedPlumeImageList {
    return PaginatedUnmatchedPlumeImageListFromJSONTyped(json, false);
}

export function PaginatedUnmatchedPlumeImageListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedUnmatchedPlumeImageList {
    if (json == null) {
        return json;
    }
    return {
        
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(UnmatchedPlumeImageFromJSON)),
    };
}

export function PaginatedUnmatchedPlumeImageListToJSON(json: any): PaginatedUnmatchedPlumeImageList {
    return PaginatedUnmatchedPlumeImageListToJSONTyped(json, false);
}

export function PaginatedUnmatchedPlumeImageListToJSONTyped(value?: PaginatedUnmatchedPlumeImageList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(UnmatchedPlumeImageToJSON)),
    };
}

